<template>
  <div class="min-h-screen bg-gray-50">
    <!-- Navigation -->
    <nav class="bg-white shadow-sm border-b border-gray-200">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex justify-between h-16">
          <div class="flex">
            <div class="flex-shrink-0 flex items-center">
              <img class="h-8 w-auto" src="/logo-mifo.svg" alt="MIFO" />
              <span class="ml-3 text-xl font-heading font-semibold text-mifo-primary">
                MIFO Admin
              </span>
            </div>
          </div>
          
          <div class="flex items-center">
            <button
              @click="logout"
              class="text-gray-500 hover:text-mifo-accent px-3 py-2 rounded-md text-sm font-medium"
            >
              Abmelden
            </button>
          </div>
        </div>
      </div>
    </nav>

    <div class="flex">
      <!-- Sidebar -->
      <div class="w-64 bg-white shadow-sm min-h-screen">
        <nav class="mt-5 px-2">
          <router-link
            to="/herzbeben/courses"
            class="mt-1 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="[
              $route.path.startsWith('/herzbeben/courses')
                ? 'bg-mifo-accent text-white'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            ]"
          >
            <GraduationCap class="mr-3 h-5 w-5 inline-block align-middle" />
            Kurse
          </router-link>

          <router-link
            to="/herzbeben/products"
            class="mt-1 group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="[
              $route.path.startsWith('/herzbeben/products')
                ? 'bg-mifo-accent text-white'
                : 'text-gray-600 hover:bg-gray-50 hover:text-gray-900'
            ]"
          >
            <Home class="mr-3 h-5 w-5 inline-block align-middle" />
            Produkte
          </router-link>
        </nav>
      </div>

      <!-- Main content -->
      <div class="flex-1">
        <main class="p-6">
          <slot />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { useRouter } from 'vue-router'
import { Home, GraduationCap } from 'lucide-vue-next'

export default {
  name: 'AdminLayout',
  components: {
    Home,
    GraduationCap
  },
  setup() {
    const router = useRouter()

    const logout = () => {
      localStorage.removeItem('auth_token')
      router.push('/herzbeben')
    }

    return {
      logout
    }
  }
}
</script> 